import { render } from "./OnboardingPropertyIcon.vue?vue&type=template&id=ba3c157e"
import script from "./OnboardingPropertyIcon.vue?vue&type=script&lang=js"
export * from "./OnboardingPropertyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__